<template>
  <transition name="fade" appear>
    <div class="modal-wrap">
      <div class="form-wrap">
        <span class="material-icons" @click="$emit('close-modal')">
          close
        </span>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {

}
</script>

<style scoped>
.modal-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  position:fixed;
  padding:0;
  margin:0;

  top:0;
  left:0;

  width: 100%;
  height: 100%;
  background:rgba(0, 0, 0, 0.6);
  z-index: 10;
}
.form-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 30%;
  max-width: 85%;
  min-height: 25%;
  max-height: 85%;
  background-color: white;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 2%;
  overflow: auto;
}
.material-icons {
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
</style>